module.exports = __webpack_public_path__ + "static/media/redux.59c46753.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/redux.png
// module id = 63
// module chunks = 0